export default "__VITE_ASSET__7013ee59__"